import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { BacklogSVG } from '@common_components/svg/backlog.svg';

const BacklogIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <BacklogSVG/>
    </div>
  );
};

export { BacklogIcon };
